<div class="breadcrumbs">
  <div class="breadcrumbs__content">
    <ul>
      <li *ngFor="let route of routes">
        <span>{{ route }}</span>
        <i>
          <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.5L4.18182 5L1 8.5" stroke="#E70F47" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </i>
      </li>
    </ul>
  </div>
</div>
